module.exports = __webpack_public_path__ + "static/media/michelle_fun.816add5d.png";